<script lang="ts" setup></script>
<template>
  <div class="registered-in-store">
    <h2 class="registered-in-store__title">{{ $t('my_account.login_page.registered_in_store.title') }}</h2>
    <p class="registered-in-store__text">{{ $t('my_account.login_page.registered_in_store.subtext') }}</p>
    <Anchor variant="secondary" url="/my-account/account-activation" class="registered-in-store__link">{{
      $t('my_account.login_page.registered_in_store.link')
    }}</Anchor>
  </div>
</template>

<style lang="postcss">
.registered-in-store {
  display: flex;
  flex-direction: column;
  gap: var(--space-50);
  width: 100%;
  .registered-in-store__title,
  .registered-in-store__text,
  .registered-in-store__link {
    margin-bottom: 0;
    width: 100%;
  }
}
</style>
